// What the API answers when the Turnstile check fails (meu-treino-api src/middlewares/turnstile.js)
export const isTurnstileError = (error) =>
  (error?.graphQLErrors || []).some((graphQLError) => graphQLError.extensions?.code === 'TURNSTILE_FAILED');
